function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 6.414V13a1 1 0 11-2 0V6.414L5.707 7.707a1 1 0 01-1.414-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L9 6.414z",
  fill: "#243143"
});

function SvgArrowSortUp16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgNi40MTQyMVYxM0M5IDEzLjU1MjMgOC41NTIyOCAxNCA4IDE0QzcuNDQ3NzIgMTQgNyAxMy41NTIzIDcgMTNWNi40MTQyMUw1LjcwNzExIDcuNzA3MTFDNS4zMTY1OCA4LjA5NzYzIDQuNjgzNDIgOC4wOTc2MyA0LjI5Mjg5IDcuNzA3MTFDMy45MDIzNyA3LjMxNjU4IDMuOTAyMzcgNi42ODM0MiA0LjI5Mjg5IDYuMjkyODlMNy4yOTI4OSAzLjI5Mjg5QzcuNjgzNDIgMi45MDIzNyA4LjMxNjU4IDIuOTAyMzcgOC43MDcxMSAzLjI5Mjg5TDExLjcwNzEgNi4yOTI4OUMxMi4wOTc2IDYuNjgzNDIgMTIuMDk3NiA3LjMxNjU4IDExLjcwNzEgNy43MDcxMUMxMS4zMTY2IDguMDk3NjMgMTAuNjgzNCA4LjA5NzYzIDEwLjI5MjkgNy43MDcxMUw5IDYuNDE0MjFaIiBmaWxsPSIjMjQzMTQzIi8+Cjwvc3ZnPgo=";
export { SvgArrowSortUp16 as ReactComponent };